import { addSharedFolderUser } from '../utils/addSharedFolderUser';
import getOtherMailboxConfiguration from '../services/getOtherMailboxConfiguration';
import { initializeSharedFolderRoots } from 'owa-folders';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import { getAggregationBucket } from 'owa-analytics-actions';
import { createLazyOrchestrator } from 'owa-bundling';

/**
 * Orchestrator that initializes shared folder roots
 */

export const initializeSharedFolderRootsOrchestrator = createLazyOrchestrator(
    initializeSharedFolderRoots,
    'initializeSharedFolderRootsOrchestratorClone',
    async actionMessage => {
        const sharedFoldersUsersResponse = await getOtherMailboxConfiguration();
        const otherMailboxEntries = sharedFoldersUsersResponse?.OtherMailboxEntries;
        if (otherMailboxEntries) {
            if (otherMailboxEntries.length > 0) {
                otherMailboxEntries.forEach(userInfo => {
                    addSharedFolderUser(
                        userInfo.DisplayName,
                        userInfo.PrincipalSMTPAddress,
                        true /* skipServerValidation */
                    );
                });
                logSharedFolderCount(otherMailboxEntries.length);
            }
        } else {
            trace.error(
                'initializeSharedFolderRoots failed with getOtherMailboxConfiguration response as : ' +
                    sharedFoldersUsersResponse
            );
        }
    }
);

/**
 * Log the Shared Folder user count on initial load.
 * @param count - number of other users the current user has added to view the shared folders
 */
function logSharedFolderCount(count: number) {
    logUsage('Triage_SharedFolders_LoadList', [getAggregationBucket({ value: count })]);
}
